import React from 'react'
import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
  styled,
} from '@mui/material'
import { Theme } from '@mui/material/styles'

const ButtonVariants = (theme: Theme) => ({
  primary: {
    styles: {
      background: `linear-gradient(to right, ${theme.palette.primary.dark}, ${theme.palette.primary.main})`,
      color: theme.palette.common.white,
      '&:hover': {
        opacity: 0.85,
      },
      '&:active': {
        opacity: 0.75,
      },
      '&.Mui-disabled': {
        background: theme.palette.grey[300],
        color: theme.palette.grey[500],
      },
    },
  },
  primaryInverted: {
    styles: {
      background: theme.palette.common.white,
      color: theme.palette.primary.main,
      '&:hover': {
        opacity: 0.85,
      },
      '&:active': {
        opacity: 0.75,
      },
      '&.Mui-disabled': {
        background: theme.palette.grey[300],
        color: theme.palette.grey[500],
      },
    },
  },
  secondary: {
    styles: {
      background: theme.palette.grey[50],
      color: theme.palette.text.primary,
      border: `1px solid ${theme.palette.grey[300]}`,
      '&:hover': {
        opacity: 0.85,
      },
      '&:active': {
        opacity: 0.75,
      },
      '&.Mui-disabled': {
        background: theme.palette.grey[300],
        color: theme.palette.grey[500],
        border: 'none',
      },
    },
  },
  text: {
    styles: {
      background: 'none',
      color: theme.palette.text.primary,
      padding: '4px 8px',
      '&:hover': {
        opacity: 0.85,
      },
      '&:active': {
        opacity: 0.75,
      },
      '&.Mui-disabled': {
        color: theme.palette.grey[500],
      },
    },
  },
})

interface ButtonProps extends MuiButtonProps {
  width?: string
  variantType?: keyof ReturnType<typeof ButtonVariants>
}

const CustomButton = styled(MuiButton, {
  shouldForwardProp: (prop) => prop !== 'variantType',
})<ButtonProps>(({ variantType, width, theme }) => ({
  width: width && width,
  borderRadius: '100px',
  textTransform: 'none',
  padding: '0 34px',
  height: '44px',
  fontWeight: 700,
  ...(variantType ? ButtonVariants(theme)[variantType].styles : {}),
}))

export const Button: React.FC<ButtonProps> = ({
  variantType = 'primary',
  ...props
}) => {
  return <CustomButton variantType={variantType} {...props} />
}
